document.querySelectorAll( '.e-sld--card-carousel-slider img' ).forEach( ( img ) => {
  img.setAttribute( 'loading', 'eager' );    
} );